import { Actionable, Icon, Popover, Text, View } from 'reshaped/bundle'
import { PopoverIcon } from './PopoverIcon'

interface Props {
	variant?: 'dark' | 'light'
}

export const AdvertiserDisclosure = ({ variant = 'dark' }: Props) => (
	<Popover>
		<Popover.Trigger>
			{attributes => (
				<Actionable attributes={attributes}>
					<View as="span" gap={1} direction="row" align="center">
						<Text as="span" color={variant === 'light' ? undefined : 'neutral-faded'}>
							Advertiser Disclosure
						</Text>
						<Icon svg={PopoverIcon} color={variant === 'light' ? undefined : 'neutral-faded'} />
					</View>
				</Actionable>
			)}
		</Popover.Trigger>
		<Popover.Content>
			The offers that appear are from companies which Engine by MoneyLion and its partners receive compensation. This
			compensation may influence the selection, appearance, and order of appearance of the offers listed below. However,
			this compensation also facilitates the provision by Engine by MoneyLion of certain services to you at no charge.
			The offers shown below do not include all financial services companies or all of their available product and
			service offerings.
		</Popover.Content>
	</Popover>
)
